import { parseAdminEnv } from '@platform/schema';

/**
 * Validated at module load, which happens before the first render. A build that
 * shipped without its configuration fails immediately with every problem listed,
 * rather than surfacing later as a network error against `undefined`.
 */
export const env = parseAdminEnv(import.meta.env);
